var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#5f00a0",
    rx: 3.333
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9 2H24V3.5H9z",
    transform: "translate(7 9) translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M0 2.116L2.298 4.414 6.711 0",
    transform: "translate(7 9) translate(1 1)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9 2H24V3.5H9z",
    transform: "translate(7 9) translate(1 9)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M0 2.116L2.298 4.414 6.711 0",
    transform: "translate(7 9) translate(1 9)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9 2H24V3.5H9z",
    transform: "translate(7 9) translate(1 17)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M0 2.116L2.298 4.414 6.711 0",
    transform: "translate(7 9) translate(1 17)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationBlue);
export default __webpack_public_path__ + "static/media/verification_blue.d5a291c9f955c6c3072b8ebf2f2acbb5.svg";
export { ForwardRef as ReactComponent };